import React, { useState, useEffect } from "react";
import axios from "axios";
import Detailtable from "../Table/detailTable";
import Footer from "../Footer";
import Navbar from "../Navbar";

const Detail = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [list, setList] = useState([]);
  const [id, setID] = useState("");
  const [date, setDate] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [outletName, setOutletName] = useState("");
  const [state, setState] = useState("");
  const [billNum, setBillNum] = useState("");
  const [discount, setDiscount] = useState("");
  const [tax, setTax] = useState("");
  const [total, setTotal] = useState("");
  const [GRN, setGRN] = useState("");

  let length = list.length;

  useEffect(() => {
    setID(sessionStorage.getItem("ID"));
    setDate(sessionStorage.getItem("date"));
    setCompanyName(sessionStorage.getItem("company name"));
    setOutletName(sessionStorage.getItem("outlet name"));
    setState(sessionStorage.getItem("state"));
    setBillNum(sessionStorage.getItem("bill num"));
    setDiscount(sessionStorage.getItem("discount"));
    setTax(sessionStorage.getItem("tax"));
    setTotal(sessionStorage.getItem("total"));
    setGRN(sessionStorage.getItem("GRN"));

    const storedDate = sessionStorage.getItem("date");
    const date = new Date(storedDate);

    if (!isNaN(date.getTime())) {
      const formattedDate = new Intl.DateTimeFormat("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      }).format(date);

      // Set the formatted date (for example, using state or some other variable)
      setDate(formattedDate); // This will now be in the 'Sun, 22 Dec 2024' format
    }
  }, []);

  // useEffect(() => {
  //   axios
  //     .get(`${baseUrl}/reqdetails/${id}`)
  //     .then((response) => {
  //       setList(response.data.intbl_purchaserequisition_contract)
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, [id]);

  useEffect(() => {
    if (id) {
      getItemDetail(id);
    }
  }, [id]);

  const getItemDetail = async (id) => {
    try {
      const result = await axios.get(`${baseUrl}/reqdetails/${id}`);
      setList(result.data.intbl_purchaserequisition_contract);
      // setGRN(result.data.grn);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-grow">
        <div className="p-4">
          <h1 className="font-medium text-lg md:text-xl font-poppins mt-3 text-center">
            {outletName}
          </h1>

          <div className="flex flex-col md:flex-row md:justify-between border-2 p-2">
            <div className="m-1 md:m-3">
              <p className="font-small md:font-medium lg:text-lg text-xs">
                Company Name:
                <span className="font-small md:font-medium px-2">
                  {companyName}
                </span>
              </p>
              <p className="font-small md:font-medium lg:text-lg text-xs">
                Date:
                <span className="font-small md:font-medium px-2">{date}</span>
              </p>
            </div>
            <div className="items-center mt-10">
              <p className="font-small md:font-medium lg:text-lg text-xs">
                GRN:
                <span className="font-small md:font-medium px-2">{GRN}</span>
              </p>
            </div>
            <div className="m-1 md:m-3">
              <p className="font-small md:font-medium lg:text-lg text-xs">
                Purchase Bill No:
                <span className="font-small md:font-medium px-2">{billNum}</span>
              </p>
              <p className="font-small md:font-medium lg:text-lg text-xs">
                State:
                <span className="text-green-500 md:font-medium font-small px-2">
                  {state}
                </span>
              </p>
            </div>
          </div>

          <Detailtable list={list} outletName={outletName} id={id} />

          <div className="flex justify-between items-center max-w-7xl p-4 mx-auto border shadow-md rounded-md">
            <div className="font-semibold text-xs md:text-base lg:text-lg">Count: <span className="px-2">{length}</span></div>

            <div className="flex space-x-6 items-center">
              <div className="text-xs md:text-base lg:text-lg font-medium">
                Discount: <span className="text-green-500 px-2">{discount}</span>
              </div>
              <div className="text-xs md:text-base lg:text-lg font-medium">
                Tax Amount: <span className="text-green-500 px-2">{tax}</span>
              </div>
              <div className="text-xs md:text-base lg:text-lg font-medium">
                Total: <span className="text-green-500 px-2">{total}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Detail;
